// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Layout from 'layout';

type Algorithm = 'top-down' | 'left-right' | 'diagonal' | 'alt-diagonal' | 'binary-tree';
type Position = { x: number; y: number };

export const calculateSpritePositions = ({
  w,
  h,
  count,
  algorithm = 'binary-tree',
  padding = 0,
}: {
  w: number;
  h: number;
  count: number;
  algorithm?: Algorithm;
  padding?: number;
}): Position[] => {
  const positions: Position[] = [];
  const layer = new Layout(algorithm);

  // 각 이미지 정보를 layout에 추가
  for (let i = 0; i < count; i++) {
    layer.addItem({
      width: w + padding,
      height: h + padding,
      meta: { index: i },
    });
  }

  // layout 계산 결과 추출
  const result = layer.export();

  // 결과를 positions 배열로 변환
  result.items.forEach((item) => {
    positions[item.meta.index] = {
      x: item.x,
      y: item.y,
    };
  });

  return positions;
};
